/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { Chrome as ChromeComponent } from 'vue-color';

  import { VM }                        from 'g3w-eventbus';
  import ApplicationState              from 'store/application';
  import GUI                           from 'services/gui';
  import { getCatalogLayerById }       from 'utils/getCatalogLayerById';
  import { downloadFeatures }          from 'utils/downloadFeatures';
  import { gettext as _ }              from 'g3w-i18n';

  /**
   * @see https://www.w3schools.com/howto/howto_js_draggable.asp 
   */
   function dragElement(menu) {
    const el = menu.querySelector('li.title');
    if (!el || menu._drag) {
      return;
    } else {
      menu._drag = true;
    }
    let x2 = 0, y2 = 0, x1 = 0, y1 = 0;
    el.addEventListener('mousedown', function(e) {
      // skip dragging on form elements
      if (['.select2-container', 'button', 'select', 'input', 'textarea'].some(i => e.target.closest(i))) {
        return;
      }
      e.preventDefault();
      x1 = e.clientX;
      y1 = e.clientY;
      document.addEventListener('mouseup', mouseUp);
      document.addEventListener('mousemove', mouseMove);
    });
    function mouseUp() {
      document.removeEventListener('mouseup', mouseUp);
      document.removeEventListener('mousemove', mouseMove);
    }
    function mouseMove(e) {
      e.preventDefault();
      x2 = x1 - e.clientX;
      y2 = y1 - e.clientY;
      x1 = e.clientX;
      y1 = e.clientY;
      if (menu.style.marginLeft) { x2 -= parseInt(menu.style.marginLeft); menu.style.marginLeft = null; }
      if (menu.style.marginTop)  { y2 -= parseInt(menu.style.marginTop);  menu.style.marginTop  = null; }
      menu.style.top  = (menu.offsetTop - y2)    + "px";
      menu.style.left = (menu.offsetLeft - x2) + "px";
    }
  }

  const __vue_script__ = {
    name: 'catalog-context-menu',

    props: {
      external: {
        type: Object
      }
    },

    data() {
      return {
        ApplicationState,
        layer:               null,
        layer_style:         null,
        top:                 0,
        left:                0,
        project_menu:        false,
        layer_menu:          false,
      };
    },

    computed: {

      edit_url() {
        return ApplicationState.project.getState().edit_url;
      },

      layers_url() {
        return ApplicationState.project.getState().layers_url;
      },

    },

    components: {
      'chrome-picker': ChromeComponent,
    },

    directives: {
      'click-outside': {
        bind(el, binding, vnode) {
          this.event = e => {
            // skip if a clicked element is a child of element
            if (el === e.target || el.contains(e.target)) {
              return;
            }
            e.stopPropagation();
            vnode.context[binding.expression](e);
          }
          document.body.addEventListener('click', this.event, true);
        },
        unbind() {
          document.body.removeEventListener('click', this.event, true);
        }
      }
    },

    methods: {

      /**
       * @since 3.10.0
       */
       async onShowContextMenu(e, layerstree) {
        this.closeMenu();
        await this.$nextTick();
        this.left         = e.x;
        const layer       = !(layerstree || {}).nodes && layerstree; // check for "layer" or "group"
        this.layer        = layer || null;
        this.layer_menu   = !!layer;
        this.project_menu = !layer;
        await this.$nextTick();
        this.top = e.target.getBoundingClientRect().top - this.$refs['menu'].clientHeight + (e.target.clientHeight / 2);
        // handle context menu on mobile
        if (window.innerWidth < 767) {
          this.left = (window.innerWidth / 2) - (this.$refs['menu'].clientWidth / 2);
          this.top  = (window.innerHeight / 2) - (this.$refs['menu'].clientHeight / 2);
        }
        // conditionally inline "ogc_menu" when they contain a single item
        [this.$refs.ogc_menu].forEach(li => li && li.classList.toggle('inline-submenu', 1 === li.querySelector('ul').children.length));
        dragElement(this.$refs.menu);
      },

      showDownloadMenu(layer) {
        downloadFeatures(undefined, layer);
        this.closeMenu();
      },

      /**
       * @param { string } menu
       */
      closeMenu() {
        this.layer_menu          = false;
        this.project_menu        = false;
      },

      onChangeColor(val) {
        this.layer.color         = val;
        this.$refs.layer_color.style.backgroundColor = val.hex;
        const layer              = GUI.getService('map').getLayerByName(this.layer.name || '');
        const style              = layer.getStyle();
        style._g3w_options.color = val;
        layer.setStyle(style);
      },

      canShowWmsUrl(layerId) {
        const layer   = getCatalogLayerById(layerId);
        const wms_url = ApplicationState.project.state.metadata.wms_url;
        return layer && !layer.isType('table') && !!(wms_url && !layer.isExternalWMS()
          ? wms_url
          : layer.getWmsUrl());
      },

      canShowWfsUrl(layerId) {
        const layer = getCatalogLayerById(layerId);
        return layer && !layer.isType('table') && layer.isWfsActive();
      },

      /**
       * @param { string } format
       * @param { string } layerId
       * 
       * @since 3.11.0
       */
      canDownload(format, layerId) {
        const layer = getCatalogLayerById(layerId);
        //exclude pdf format. It is used only for single feature download
        return layer && layer.getDownloadableFormats().filter(f => 'pdf' !== f).length && layer['is' + format + 'Downloadable']();
      },

      getWmsUrl(layerId) {
        const wms_url = ApplicationState.project.state.metadata.wms_url;
        const layer = getCatalogLayerById(layerId);
        return wms_url && !layer.isExternalWMS()
          ? wms_url
          : `${layer.getWmsUrl()}?service=WMS&version=1.3.0&request=GetCapabilities`;
      },

      getWfsUrl(layerId) {
        return `${getCatalogLayerById(layerId).getWfsUrl()}?service=WFS&version=1.1.0&request=GetCapabilities`;
      },

      /**
       * @param layerId
       * @returns { String } wfs3 url
       * 
       * @since 3.10.0
       */
      getWfs3Url(layerId) {
        return `${getCatalogLayerById(layerId).getWfsUrl()}wfs3/`;
      },

      /**
       * @param { 'Wms', 'Wfs', 'Wfs3' } format
       * @param { HTMLElement } el
       */
      copyUrl(format, el) {
        const url   = this[`get${format}Url`](this.layer.id);
        const a     = document.createElement('a');
        const input = document.createElement('input');
        a.href      = url;
        input.value = a.href;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        el.setAttribute('title', _('Copied'));
        el.setAttribute('data-i18n-title', _('Copied'));
        input.remove();
        a.remove();
        setTimeout(() => {
          this.closeMenu();
        }, 600);
      },

      /**
       * @param { 'top', 'bottom' } position 
       */
      setLayerPosition(position) {
        if (position !== this.layer.position) {
          this.layer.position = position;
          const map           = GUI.getService('map');
          map.getLayerById(this.layer.id).setZIndex(({ top: map.layersCount, bottom: 0 })[position]);
          map.emit('change-layer-position-map', { id: this.layer.id, position });
          this.closeMenu();
        }
      },

      /**
       * @TODO refactor this, almost the same as: `CatalogTristateTree.vue::zoomToLayer(layer))`
       *
       * @FIXME add description
       *
       * @param layer
       */
      zoomToLayer(layer) {
        try {
          GUI
            .getService('map')
            .goToBBox(
              [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy],
              layer.epsg
            );

        } catch(e) {
          console.warn(e);
          GUI.showUserMessage({
            type:        'alert',
            message:     `${e.message}`,
            textMessage: true,
          })
        }
        this.closeMenu();
      },

      /**
       * @returns {Boolean} whether layer is editable
       * @since 3.11.0
       */
       canEdit(layer) {
        return layer ? !layer.external && getCatalogLayerById(layer.id).isEditable() && getCatalogLayerById(layer.id).config.editing.visible: g3wsdk.core.plugin.PluginsRegistry.getPlugin('editing');
      },

      /**
       * @since 3.11.0
       */
       startEditing(layer) {
        this.closeMenu();
        const editing = g3wsdk.core.plugin.PluginsRegistry.getPlugin('editing');
        editing.showPanel(layer ? { toolboxes: [layer.id] } : undefined);
        if (layer) {
          editing.startEditing(layer.id);
        }
      },

      /**
       * @TODO refactor this, almost the same as: `CatalogTristateTree.vue::canZoom(layer))`
       *
       * Check if layer has bbox property
       *
       * @param layer
       */
      canZoom(layer) {
        return (layer.bbox && [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy].find(coord => coord > 0));
      },

      getGeometryType(layerId, external=false) {
        const layer = external ? GUI.getService('catalog').state.external.vector.find(l => layerId === l.id) : getCatalogLayerById(layerId);
        if (layer) {
          const type = external ? layer.geometryType : layer.config.geometrytype;
          return layer && 'NoGeometry' !== type && type || '';
        }
        return '';
      },

      showAttributeTable(layerId) {
        getCatalogLayerById(layerId).openAttributeTable();
        this.closeMenu();
      },

      async showMetadata(layerId){
        this.closeMenu();
        $('#modal-metadata').modal('show');
        if (layerId) {
          setTimeout(() => {
            document.querySelector('#project-catalog [href="#metadata_layers"]').click();
            document.querySelector('#metadata_layers [data-target="#' + layerId + '"]').click();
          });
        }
      },

      setLayerStyle(index) {
        this.layer_style = this.layer.styles[index].name;
        //change layer style
        getCatalogLayerById(this.layer.id).changeCurrentStyle(this.layer_style);
        this.closeMenu();
      },

      /**
       * Set current filter
       *
       * @param filter
       *
       * @since 3.9.0
       */
      async setLayerFilter(filter) {
        const changed = (
          null === this.layer.filter.current ||
          filter.fid !== this.layer.filter.current.fid 
        );
        const layer = getCatalogLayerById(this.layer.id);
        if (changed) {
          await layer.applyFilter(filter);
        } else {
          await layer.deleteFilterToken();
        }
        layer.change();
        this.closeMenu();
      },

      /**
       * Delete filter from saved filters
       *
       * @param fid
       *
       * @returns { Promise<void> }
       *
       * @since 3.9.0
       */
      async deleteFilter(fid) {
        const layer  = getCatalogLayerById(this.layer.id);
        // No found catalog layer
        if (!layer) { return }
        const change = fid === this.layer.fid;
        await layer.deleteFilterToken(fid);
        if (change) { layer.change() }
        this.closeMenu();
      },

      /**
       * Context menu: toggle "styles" submenu handling its correct horizontal and vertical alignment
       * 
       * @param { string } menu
       * @param { HTMLElement } target
       */
      async showMenu(e) {
        const li = e.target.closest('li');
        const ul = li && li.querySelector('ul');
        if (ul) {
          const overflowY    = (ul.offsetHeight + ul.getBoundingClientRect().top) >= (this.$refs['menu'].offsetHeight + this.$refs['menu'].getBoundingClientRect().top);
          ul.style.top       = ul.offsetHeight > this.$refs['menu'].offsetHeight ? 0 : undefined;
          ul.style.left      = this.$refs['menu'].offsetWidth -2 + 'px';
          ul.style.maxHeight = this.$refs['menu'].offsetHeight + 'px';
          ul.style.bottom    = overflowY ? 0         : undefined;
          ul.style.marginTop = overflowY ? undefined : '-5px';
          ul.style.overflowY = 'auto';
        }
      },

      /**
       * @since 3.10.0
       */
      canOpenAttributeTable(layer) {
        return layer.openattributetable;
      },

      /**
       * @since 3.10.0
       */
      isExternalLayer(layer) {
        return !layer.projectLayer;
      },

      /**
       * @since 3.8.3
       */
      isExternalWMSLayer(layer) {
        return !layer.projectLayer && 'wms' === layer._type;
      },

      /**
       * @since 3.8.3
       */
       isExternalVectorLayer(layer) {
        return !layer.projectLayer && 'wms' !== layer._type;
      },

      /**
       * @since 3.8.3
       */
      canShowStylesMenu(layer) {
        return layer.styles && layer.styles.length > 1;
      },

      /**
       * @returns { boolean } whether it can show filters menu
       *
       * @since 3.9.0
       */
      canShowFiltersMenu(layer) {
        return layer.filters && layer.filters.length > 0;
      },

      /**
       * @since 3.8.3
       */
      hasMetadata(layer) {
        return layer.metadata /*&& layer.metadata.abstract*/;
      },

      /**
       * @since 3.8.3
       */
      canShowOpacityPicker(layer) {
        return layer.geolayer && layer.visible;
      },

      /**
       * @param {{ id:? string, value: number }}
       * 
       * @fires VM~layer-change-opacity
       * 
       * @since 3.11.0
       */
       onLayerOpacity() {
        if (this.isExternalWMSLayer(this.layer)) {
          const layer = GUI.getService('map').getLayerById(this.layer.id);
          if (layer) {
            layer.setOpacity(Number(this.layer.opacity));
            GUI.getService('map').emit('change-layer-opacity', { id: this.layer.id, opacity: this.layer.opacity });
          }
        } else {
          const layer = getCatalogLayerById(this.layer.id);
          if (layer) {
            VM.$emit('layer-change-opacity', { layerId: this.layer.id });
            layer.change();
          }
        }

      },

    },

    /**
     * @listens VM~context-menu
     */
    created() {
      VM.$on('context-menu', this.onShowContextMenu);
      document.addEventListener('keyup', e => 'Escape' === e.key && this.closeMenu());
    },

  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layer_menu || _vm.project_menu)?_c('ul',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeMenu),expression:"closeMenu"}],ref:"menu",staticClass:"catalog-context-menu",style:({
    top:  _vm.top + 'px',
    left: _vm.left + 'px',
  }),attrs:{"id":"layer-context-menu","tabindex":"-1"},on:{"mouseover":_vm.showMenu}},[_c('li',{staticClass:"title"},[(_vm.project_menu)?_c('div',[_vm._v("G3W-ADMIN "+_vm._s(_vm.ApplicationState.project.getName()))]):_c('div',[_vm._v("\n      "+_vm._s(_vm.layer.title)+"\n      "),_c('div',{staticStyle:{"font-weight":"normal","font-size":"0.8em"}},[_vm._v("\n        "+_vm._s(_vm.getGeometryType(_vm.layer.id, _vm.layer.external))+"\n      ")])])]),_vm._v(" "),(_vm.project_menu || _vm.hasMetadata(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showMetadata(_vm.layer && _vm.layer.id)}}},[_c('i',{class:_vm.$fa('info')}),_vm._v(" "+_vm._s(_vm.$t('Metadata'))+"\n    "),(_vm.layer && _vm.layer.metadata && _vm.layer.metadata.abstract)?_c('ul',{staticClass:"sub-contex-menu",staticStyle:{"border-radius":"0 3px 3px 0"}},[_c('li',{staticClass:"layer-menu-metadata-info",domProps:{"innerHTML":_vm._s(_vm.layer.metadata.abstract)}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.canEdit(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.startEditing(_vm.layer)}}},[_c('i',{class:_vm.$fa('pencil')}),_vm._v(" "+_vm._s(_vm.$t('Edit Layer'))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.layer_menu)?[(_vm.canZoom(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.zoomToLayer(_vm.layer)}}},[_c('i',{class:_vm.$fa('search')}),_vm._v(" "+_vm._s(_vm.$t('Zoom to Layer'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.canOpenAttributeTable(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showAttributeTable(_vm.layer.id)}}},[_c('i',{class:_vm.$fa('list')}),_vm._v(" "+_vm._s(_vm.$t('Open Attribute Table'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.isExternalLayer(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('sort')}),_vm._v("\n      "+_vm._s(_vm.$t('layer_position.message'))+" ("+_vm._s(_vm.$t('layer_position.' + _vm.layer.position))+")\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},_vm._l((['top', 'bottom']),function(position){return _c('li',{staticStyle:{"display":"list-item"},on:{"click":function($event){return _vm.setLayerPosition(position)}}},[(position === _vm.layer.position)?_c('span',{class:_vm.$fa('circle'),staticStyle:{"font-size":"0.5em","margin-right":"3px"}}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('layer_position.' + position),expression:"'layer_position.' + position"}]})])}),0)]):_vm._e(),_vm._v(" "),(_vm.canShowStylesMenu(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('palette')}),_vm._v("\n      "+_vm._s(_vm.$t('Style'))+" ("+_vm._s(_vm.layer.styles.find(function (s) { return s.current; }).name.toLowerCase())+")\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},_vm._l((_vm.layer.styles),function(style,i){return _c('li',{key:style.name,staticStyle:{"display":"list-item"},on:{"click":function($event){$event.stopPropagation();return _vm.setLayerStyle(i)}}},[(style.current)?_c('span',{class:_vm.$fa('circle'),staticStyle:{"font-size":"0.8em"}}):_vm._e(),_vm._v("\n          "+_vm._s(style.name + (_vm.layer.styles.length > 1 && style.name === _vm.layer.defaultstyle ? (" (" + (_vm.$t('default')) + ")") : ''))+"\n        ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.canShowOpacityPicker(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('slider')}),_vm._v("\n      "+_vm._s(_vm.$t('Opacity'))+" ("+_vm._s((_vm.layer.opacity / 100))+")\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},[_c('li',{staticStyle:{"display":"list-item"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer.opacity),expression:"layer.opacity"}],attrs:{"type":"range","min":"0","max":"100","step":"1","list":"opacity-markers"},domProps:{"value":(_vm.layer.opacity)},on:{"change":_vm.onLayerOpacity,"__r":function($event){return _vm.$set(_vm.layer, "opacity", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])])]):_vm._e(),_vm._v(" "),(_vm.isExternalWMSLayer(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('slider')}),_vm._v("\n      "+_vm._s(_vm.$t('Opacity'))+" ("+_vm._s(_vm.layer.opacity)+")\n      "),_c('span',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},[_c('li',{staticStyle:{"display":"list-item"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer.opacity),expression:"layer.opacity"}],attrs:{"type":"range","min":"0","max":"1","step":"0.01","list":"opacity-markers"},domProps:{"value":(_vm.layer.opacity)},on:{"change":_vm.onLayerOpacity,"__r":function($event){return _vm.$set(_vm.layer, "opacity", $event.target.value)}}}),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),(_vm.isExternalVectorLayer(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('tint')}),_vm._v("\n      "+_vm._s(_vm.$t('Color'))+"\n      "),_c('i',{ref:"layer_color",staticStyle:{"width":"10px","height":"10px","border-radius":"10px","position":"absolute","right":"20px","margin-top":"4px"},style:({ backgroundColor: _vm.layer.color })}),_vm._v(" "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},[_c('li',{staticStyle:{"padding":"14px","background-color":"#E0E0E0"}},[_c('chrome-picker',{ref:"color_picker",staticStyle:{"width":"100%"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();},"hook:beforeDestroy":function () { return _vm.$refs.color_picker.$off(); },"input":_vm.onChangeColor},model:{value:(_vm.layer.color),callback:function ($$v) {_vm.$set(_vm.layer, "color", $$v)},expression:"layer.color"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.canShowFiltersMenu(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('filter')}),_vm._v("\n      "+_vm._s(_vm.$t('Filters'))+"\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},_vm._l((_vm.layer.filters),function(filter){return _c('li',{key:filter.fid,staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){$event.stopPropagation();return _vm.setLayerFilter(filter)}}},[(_vm.layer.filter.current && _vm.layer.filter.current.fid === filter.fid)?_c('span',{class:_vm.$fa('circle'),staticStyle:{"font-size":"0.5em","margin-right":"3px","justify-self":"flex-start"}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"5px"}},[_vm._v(_vm._s(filter.name))]),_vm._v(" "),_c('span',{staticClass:"skin-border-color",class:_vm.$fa('trash'),staticStyle:{"color":"red","right":"0","padding-left":"10px","border-left":"2px solid"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteFilter(filter.fid)}}})])}),0)]):_vm._e(),_vm._v(" "),(_vm.canDownload('', _vm.layer.id) || _vm.isExternalVectorLayer(_vm.layer))?_c('li',{attrs:{"disabled":_vm.ApplicationState.download},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showDownloadMenu(_vm.layer)}}},[_c('i',{class:_vm.$fa('download')}),_vm._v("\n      "+_vm._s(_vm.$t('Download'))+"\n    ")]):_vm._e(),_vm._v(" "),([
        this.canShowWmsUrl(this.layer.id),
        this.canShowWfsUrl(this.layer.id),
        this.canShowWfsUrl(this.layer.id)
      ].filter(Boolean).length)?_c('li',{ref:"ogc_menu"},[_c('i',{class:_vm.$fa('map')}),_vm._v(" "+_vm._s(_vm.$t('OGC Services'))+"\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},[(_vm.canShowWmsUrl(_vm.layer.id))?_c('li',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){return _vm.copyUrl('Wms', $event.target)}}},[_c('a',{staticStyle:{"color":"#000"},attrs:{"href":_vm.getWmsUrl(_vm.layer.id),"target":"_blank"}},[_c('i',{class:_vm.$fa('map')}),_vm._v(" WMS\n          ")]),_vm._v(" "),_c('b',{staticClass:"click-to-copy skin-color-dark",class:_vm.$fa('eye'),attrs:{"data-placement":"top","title":_vm.getWmsUrl(_vm.layer.id)}})]):_vm._e(),_vm._v(" "),(_vm.canShowWfsUrl(_vm.layer.id))?_c('li',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){return _vm.copyUrl('Wfs', $event.target)}}},[_c('a',{staticStyle:{"color":"#000"},attrs:{"href":_vm.getWfsUrl(_vm.layer.id),"target":"_blank"}},[_c('i',{class:_vm.$fa('map')}),_vm._v(" WFS\n          ")]),_vm._v(" "),_c('b',{staticClass:"click-to-copy skin-color-dark",class:_vm.$fa('eye'),attrs:{"data-placement":"top","title":_vm.getWfsUrl(_vm.layer.id)}})]):_vm._e(),_vm._v(" "),(_vm.canShowWfsUrl(_vm.layer.id))?_c('li',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){return _vm.copyUrl('Wfs3', $event.target)}}},[_c('a',{staticStyle:{"color":"#000"},attrs:{"href":_vm.getWfs3Url(_vm.layer.id),"target":"_blank"}},[_c('i',{class:_vm.$fa('map')}),_vm._v(" WFS 3\n          ")]),_vm._v(" "),_c('b',{staticClass:"click-to-copy skin-color-dark",class:_vm.$fa('eye'),attrs:{"data-placement":"top","title":_vm.getWfs3Url(_vm.layer.id)}})]):_vm._e()])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.layers_url && _vm.layer_menu && !_vm.isExternalLayer(_vm.layer))?_c('li',[_c('a',{staticStyle:{"color":"initial"},attrs:{"href":_vm.layers_url,"target":"_blank"}},[_c('i',[_c('svg',{staticStyle:{"height":"14px","vertical-align":"-1.5px","fill":"currentColor"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"m17.61 17.63 4.36-.02-4-3.98h-4.36v4l4 4.45z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m31.61 27.22-7.62-7.6-4.38.01v4.33l7.24 7.67h4.76z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 25.18c-.68.16-1.17.2-1.9.2a9.77 9.77 0 0 1-9.68-9.88c0-5.57 4.4-9.78 9.68-9.78s9.48 4.2 9.48 9.78c0 .91-.15 1.96-.36 2.8l4.88 4.65a15 15 0 0 0 1.95-7.48C32.05 6.87 25.19.44 16 .44 6.86.44 0 6.84 0 15.47c0 8.68 6.86 15.2 16 15.2 2.36 0 4.23-.3 6.2-1.1L18 25.18z"}})])]),_vm._v("\n      Layers settings\n      "),_c('i',{class:_vm.$fa('external-link'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}})])]):_vm._e(),_vm._v(" "),(_vm.edit_url && _vm.project_menu)?_c('li',[_c('a',{staticStyle:{"color":"initial"},attrs:{"href":_vm.edit_url,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();return _vm.closeMenu.apply(null, arguments)}}},[_c('i',[_c('svg',{staticStyle:{"height":"14px","vertical-align":"-1.5px","fill":"currentColor"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"m17.61 17.63 4.36-.02-4-3.98h-4.36v4l4 4.45z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m31.61 27.22-7.62-7.6-4.38.01v4.33l7.24 7.67h4.76z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 25.18c-.68.16-1.17.2-1.9.2a9.77 9.77 0 0 1-9.68-9.88c0-5.57 4.4-9.78 9.68-9.78s9.48 4.2 9.48 9.78c0 .91-.15 1.96-.36 2.8l4.88 4.65a15 15 0 0 0 1.95-7.48C32.05 6.87 25.19.44 16 .44 6.86.44 0 6.84 0 15.47c0 8.68 6.86 15.2 16 15.2 2.36 0 4.23-.3 6.2-1.1L18 25.18z"}})])]),_vm._v("\n      Project settings\n      "),_c('i',{class:_vm.$fa('external-link'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}})])]):_vm._e()],2):_vm._e()}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"opacity-markers"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("0.25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("0.50")]),_vm._v(" "),_c('option',{attrs:{"value":"75"}},[_vm._v("0.75")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"opacity-markers"}},[_c('option',[_vm._v("0")]),_vm._v(" "),_c('option',[_vm._v("0.25")]),_vm._v(" "),_c('option',[_vm._v("0.50")]),_vm._v(" "),_c('option',[_vm._v("0.75")]),_vm._v(" "),_c('option',[_vm._v("1")])])}]

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-159b2a46_0", { source: ".catalog-context-menu{background:#fafafa;border:1px solid #bdbdbd;border-radius:3px;display:block;list-style:none;margin:0;padding:0;position:fixed;min-width:150px;z-index:2;color:#000;outline:0;display:flex;flex-direction:column}.catalog-context-menu li ul{position:absolute;width:max-content;order:1;padding-left:0;background-color:#fff;color:#000}.catalog-context-menu li:not(:hover) ul{display:none}.catalog-context-menu li{border-bottom:1px solid #e0e0e0;margin:0;padding:8px 25px 8px 15px;display:flex;flex-direction:row}.catalog-context-menu li:not(.title){align-items:center}.catalog-context-menu li i{padding-right:3px;margin-right:6px;color:hsl(from var(--skin-color) h s calc(l - 20))!important}.catalog-context-menu li .click-to-copy{color:#000;opacity:1;margin-left:1ch;margin-right:-15px;margin-top:8px}.catalog-context-menu li .click-to-copy:hover{color:#fff!important;transform:scale(1.1)}.catalog-context-menu .click-to-copy .tooltip-inner{min-width:200px}.catalog-context-menu li.title{background:0 0!important;font-size:1.1em;font-weight:700;border-bottom-width:3px!important;flex-direction:column;max-width:250px;cursor:move!important;color:#000!important}.catalog-context-menu li:last-child{border-bottom:none}.catalog-context-menu li:hover{color:#fafafa;cursor:pointer}.catalog-context-menu li .layer-menu-metadata-info{background-color:#fff;color:#000;padding:5px;max-width:200px;white-space:normal;overflow-y:auto;max-height:150px}.catalog-context-menu .tooltip-inner{word-break:break-all;font-weight:700}.catalog-context-menu .item-text{margin-left:3px}.catalog-context-menu :is(ul,li){list-style-type:none}.catalog-context-menu li.inline-submenu{display:list-item;padding:0;text-indent:100%;line-height:0;overflow:hidden}.catalog-context-menu li.inline-submenu>*{display:none}.catalog-context-menu li.inline-submenu>ul{display:block;position:relative;left:0!important;width:100%;text-indent:0;line-height:initial}.catalog-context-menu li,.catalog-context-menu li.inline-submenu>ul>li{font-weight:700}.catalog-context-menu li li{font-weight:400}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CatalogContextMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__